<script lang="ts">
  import { getContext, onMount, untrack } from "svelte";
  import clickoutside from "./actions/clickoutside";
  import { ensurevisible } from "./actions/ensurevisible";
  import { menuFirst, menuKey, type MenuPath } from "./menu-nav";
  import MenuItems from "./MenuItems.svelte";
  import { throwIf } from "./util";

  let dismissContextMenu = getContext("fnDismissContextMenu") as () => void;
  throwIf(!dismissContextMenu, "needs dismissContextMenu");

  interface Props {
    menu?: any;
    pageX?: number;
    pageY?: number;
    // true when opened with the keyboard: the first item starts selected
    selectFirst?: boolean;
  }

  let { menu = [], pageX = 0, pageY = 0, selectFirst = false }: Props = $props();

  let el: HTMLElement | undefined = $state();
  // the one selected item, changed by the keys or by moving the mouse
  let path: MenuPath = $state(untrack(() => (selectFirst ? menuFirst(menu) : [])));

  // while the menu is open the keys are its own
  onMount(() => {
    el?.focus();
  });

  function onKeyDown(ev: KeyboardEvent) {
    if (ev.ctrlKey || ev.altKey || ev.metaKey) {
      return;
    }
    ev.stopPropagation();
    let res = menuKey(menu, path, ev.key);
    if (!res.handled) {
      return;
    }
    // also keeps Enter from clicking the focused menu
    ev.preventDefault();
    path = res.path;
    if (res.run) {
      res.run.handler?.();
      dismissContextMenu();
    } else if (res.close) {
      dismissContextMenu();
    }
  }
</script>

<button
  class="context-menu absolute block text-black cursor-pointer z-50"
  style="top: {pageY}px; left: {pageX}px; outline: none"
  bind:this={el}
  onclick={dismissContextMenu}
  onkeydown={onKeyDown}
  use:clickoutside
  use:ensurevisible
  onclickoutside={dismissContextMenu}
>
  <MenuItems {menu} {path} onselect={(p) => (path = p)} />
</button>
